var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.allowShow)?_c('rate-comment',{ref:"rateComment",attrs:{"progress":_vm.progress,"inEdit":_vm.inEdit},on:{"submit":_vm.onSubmit,"cancel":_vm.onCancel,"needEdit":_vm.onNeedEdit},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }